import { QuickApiServiceBase, QuickConsoleLogger } from 'hooks/services';
import { appApiProvider } from './axiosApiProvider';
import { appConfig } from 'config';

// Interfaces for file operations
export interface TemporaryFileUploadResponse {
    success: boolean;
    message: string;
    file?: {
        fileId: string;
        fileName: string;
        fileSize: number;
        fileExtension: string;
        uploadDate: string;
        applicationId: string;
        fieldIndex: number;
        isTemporary?: boolean;
        expiresAt?: Date | string;
        uploadedAt?: Date | string;
    };
    error?: {
        type: string;
        message: string;
        details?: any;
    };
}

export interface TemporaryFileDeleteResponse {
    success: boolean;
    message: string;
    fileId?: string;
    error?: {
        type: string;
        message: string;
        details?: any;
    };
}

class FilesService extends QuickApiServiceBase {
    constructor() {
        super(new QuickConsoleLogger('FilesService'), appApiProvider, 'files/temporary', 'Files');
    }

    //Upload a temporary file

    public async uploadTemporary(
        file: File,
        applicationId: string,
        fieldIndex: number,
        applicationCategory?: string,
        formId?: string,
        attachmentType: string = 'field-attachment'
    ): Promise<TemporaryFileUploadResponse> {
        console.log('📤 FilesService - Building FormData:', {
            fileName: file.name,
            applicationId,
            fieldIndex,
            applicationCategory,
            formId,
            attachmentType,
        });

        const formData = new FormData();
        formData.append('file', file);
        formData.append('applicationId', applicationId);
        formData.append('fieldIndex', fieldIndex.toString());
        formData.append('category', applicationCategory || 'no-category');
        formData.append('formName', formId || 'external-application');
        formData.append('attachmentType', attachmentType);
        formData.append('uploadedBy', applicationId);

        return this.postOrThrow(formData, { url: '' });
    }

    // Delete a temporary file

    // applicationId query param is used by the axios interceptor to attach the correct OTP session token.
    // It is NOT forwarded to the server — ExternalRequestsApi resolves applicationId from the file record in DB.
    public async removeTemporary(fileId: string, applicationId?: string): Promise<TemporaryFileDeleteResponse> {
        const query = applicationId ? `?applicationId=${applicationId}` : '';
        return this.deleteOrThrow({ url: `/${fileId}${query}` });
    }

    // Generate file view URL for opening files in new window/tab (both temporary and permanent)

    public getFileViewUrl(fileId: string): string {
        const baseUrl = appConfig.backendUrl;
        const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
        console.log('📤 FilesService - Generating view URL:', {
            fileId: fileId,
            cleanBaseUrl: cleanBaseUrl,
            url: `${cleanBaseUrl}/files/${fileId}/content`,
        });
        return `${cleanBaseUrl}/files/${fileId}/content`;
    }
}

export const filesService = new FilesService();
